export enum NetvisorApprovalStatus {
    OPEN = 'open',
    IN_FACTUAL_VERIFICATION = 'infactualverification',
    CONTENT_SUPERVISOR_REJECTED = 'contentsupervisorrejected',
    APPROVED = 'approved',
    ACCEPTED = 'accepted',
    ACCEPTOR_REJECTED = 'acceptorrejected',
}
